export default [
  {
    id: 'N/A',
    name: 'Select your company',
  },
  {
    id: 'alaskaair',
    name: 'Alaska Airlines',
  },
  {
    id: 'alliant',
    name: 'Alliant Credit Union',
  },
  {
    id: 'ally',
    name: 'Ally Bank',
  },
  {
    id: 'amex',
    name: 'American Express',
  },
  {
    id: 'autoowners',
    name: 'Auto Owners Insurance',
  },
  {
    id: 'bofa',
    name: 'Bank of America',
  },
  {
    id: 'bestegg',
    name: 'Best Egg',
  },
  {
    id: 'bilt',
    name: 'Bilt',
  },
  {
    id: 'capitalone',
    name: 'Capital One',
  },
  {
    id: 'chase',
    name: 'Chase',
  },
  {
    id: 'choice',
    name: 'Choice',
  },
  {
    id: 'citi',
    name: 'Citibank',
  },
  {
    id: 'discover',
    name: 'Discover',
  },
  {
    id: 'fidelity',
    name: 'Fidelity Investments',
  },
  {
    id: 'flagstar',
    name: 'Flagstar Bank',
  },
  {
    id: 'interactivebrokers',
    name: 'Interactive Brokers',
  },
  {
    id: 'lemonade',
    name: 'Lemonade',
  },
  {
    id: 'lightstream',
    name: 'LightStream',
  },
  {
    id: 'nbkc',
    name: 'NBKC Bank',
  },
  {
    id: 'networkcapital',
    name: 'Network Capital',
  },
  {
    id: 'pnc',
    name: 'PNC Bank',
  },
  {
    id: 'rocket',
    name: 'Rocket Mortgage',
  },
  {
    id: 'schwab',
    name: 'Schwab Bank',
  },
  {
    id: 'sofi',
    name: 'SoFi',
  },
  {
    id: 'travelers',
    name: 'Travelers',
  },
  {
    id: 'ufbdirect',
    name: 'UFB Direct',
  },
  {
    id: 'unitedexplorer',
    name: 'United Explorer',
  },
  {
    id: 'upgrade',
    name: 'Upgrade',
  },
  {
    id: 'upstart',
    name: 'Upstart',
  },
  {
    id: 'usbank',
    name: 'U.S. Bank',
  },
  {
    id: 'vanguard',
    name: 'Vanguard',
  },
  {
    id: 'viobank',
    name: 'Vio Bank',
  },
  {
    id: 'wealthfront',
    name: 'Wealthfront',
  },
  {
    id: 'wellsfargo',
    name: 'Wells Fargo',
  },
  {
    id: 'worldofhyatt',
    name: 'World of Hyatt',
  },
  {
    id: 'zoefinancial',
    name: 'Zoe Financial',
  },
];
